import type { DiagramType } from '../../lib/diagram/registries';

export function getRelationshipIcon(subtypeId: string, diagramType: DiagramType = 'genogram'): string | null {
  if (diagramType !== 'genogram' && diagramType !== 'org') return null;
  const folder = diagramType === 'org' ? 'org' : 'genogram';
  return `/assets/relationships/${folder}/${subtypeId}.svg`;
}
